<template>
  <section class="personal-center-panel">
    <h2>账户资料</h2>
    <label class="profile-field">
      会员编号
      <input :value="front.memberNoDisplay" type="text" disabled />
    </label>
    <label class="profile-field">邮箱<input v-model="front.profileForm.email" type="email" disabled /></label>
    <label class="profile-field">姓名<input v-model="front.profileForm.userName" type="text" /></label>
    <label class="profile-field">
      性别
      <select v-model="front.profileForm.gender">
        <option disabled value="">请选择</option>
        <option value="男">男</option>
        <option value="女">女</option>
      </select>
    </label>
    <label class="profile-field">学校/单位<input v-model="front.profileForm.unit" type="text" /></label>
    <label class="profile-field">
      学校/单位税号
      <input v-model="front.profileForm.orgCreditCode" type="text" maxlength="32" placeholder="可选，便于开票" />
    </label>
    <label class="profile-field">职称<input v-model="front.profileForm.title" type="text" /></label>
    <label class="profile-field">职务类型<input v-model="front.profileForm.roleLabel" type="text" disabled /></label>
    <label class="profile-field">档案会员类别<input :value="front.memberTypeDisplayLabel" type="text" disabled /></label>
    <button type="button" class="primary-action compact" @click="front.submitProfile">保存资料</button>
  </section>
</template>

<script>
export default {
  name: 'PersonalAccountPanel',
  inject: ['front']
}
</script>
